/**
 * onboarding.js — Mini-historia animada de bienvenida (feed, kudos, cursos).
 * Se muestra a usuarios nuevos (si admin lo habilita) y desde un botón "¿Cómo funciona?".
 */
const Onboarding = (() => {
  const SEEN_KEY = 'intranet_onboarding_seen';
  let _step = 0;

  const STEPS = [
    {
      icon: 'bi-emoji-smile',
      art: `<div class="ob-art ob-welcome">
              <div class="ob-blob"></div>
              <div class="ob-logo-pop"><i class="bi bi-heart-pulse"></i></div>
            </div>`,
      title: '¡Bienvenido/a a tu Portal de Bienestar!',
      text: 'Un solo lugar para tu desarrollo, tu equipo y tu bienestar. Te mostramos lo esencial en 30 segundos.',
    },
    {
      icon: 'bi-chat-square-text',
      art: `<div class="ob-art">
              <div class="ob-post ob-post-1">
                <div class="ob-avatar" style="background:#3498db">MR</div>
                <div class="ob-lines"><span></span><span></span></div>
              </div>
              <div class="ob-post ob-post-2">
                <div class="ob-avatar" style="background:#e67e22">JL</div>
                <div class="ob-lines"><span></span><span></span></div>
              </div>
              <div class="ob-reactions">
                <span class="ob-react ob-r1"><i class="bi bi-hand-thumbs-up-fill"></i></span>
                <span class="ob-react ob-r2"><i class="bi bi-heart-fill"></i></span>
                <span class="ob-react ob-r3"><i class="bi bi-stars"></i></span>
              </div>
            </div>`,
      title: 'El Feed: la voz del equipo',
      text: 'Comparte logros, novedades y momentos de bienestar. Reacciona, comenta y mantente al día con todo lo que pasa en la empresa.',
    },
    {
      icon: 'bi-star-fill',
      art: `<div class="ob-art">
              <div class="ob-kudo-card">
                <div class="ob-kudo-badge"><i class="bi bi-star-fill"></i></div>
                <div class="ob-kudo-arrow">
                  <div class="ob-avatar" style="background:#9b59b6">AN</div>
                  <i class="bi bi-arrow-right"></i>
                  <div class="ob-avatar" style="background: var(--green)">CP</div>
                </div>
              </div>
              <div class="ob-confetti">
                <span></span><span></span><span></span><span></span><span></span>
              </div>
            </div>`,
      title: 'Kudos: reconoce a tus compañeros',
      text: 'Cada semana tienes 5 reconocimientos para regalar. Dale las gracias a quien te ayudó, destaca el buen trabajo y haz crecer la cultura del equipo.',
    },
    {
      icon: 'bi-mortarboard',
      art: `<div class="ob-art ob-grid-art">
              <div class="ob-mini-card" style="--d:0"><i class="bi bi-journal-text"></i><span>Cursos</span></div>
              <div class="ob-mini-card" style="--d:.15s"><i class="bi bi-calendar-event"></i><span>Eventos</span></div>
              <div class="ob-mini-card" style="--d:.3s"><i class="bi bi-cake2"></i><span>Celebra</span></div>
              <div class="ob-mini-card" style="--d:.45s"><i class="bi bi-clipboard-check"></i><span>Encuestas</span></div>
            </div>`,
      title: 'Y mucho más...',
      text: 'Toma cursos y gana certificados, inscríbete a eventos, celebra cumpleaños y aniversarios, y comparte tu opinión en encuestas.',
    },
  ];

  function shouldShow() {
    const branding = window._branding;
    const seen = localStorage.getItem(SEEN_KEY);
    return branding?.show_landing && !seen;
  }

  function open(force = false) {
    _step = 0;
    let ov = document.getElementById('ob-overlay');
    if (ov) ov.remove();
    ov = document.createElement('div');
    ov.id = 'ob-overlay';
    ov.className = 'ob-overlay';
    ov.innerHTML = `
      <div class="ob-modal">
        <button class="ob-skip" id="ob-skip">Saltar <i class="bi bi-x-lg"></i></button>
        <div class="ob-stage" id="ob-stage"></div>
        <div class="ob-footer">
          <div class="ob-dots" id="ob-dots"></div>
          <button class="btn btn-primary" id="ob-next">Siguiente <i class="bi bi-arrow-right"></i></button>
        </div>
      </div>`;
    document.body.appendChild(ov);
    document.getElementById('ob-skip').addEventListener('click', close);
    document.getElementById('ob-next').addEventListener('click', next);
    renderStep();
  }

  function renderStep() {
    const s = STEPS[_step];
    const stage = document.getElementById('ob-stage');
    stage.innerHTML = `
      <div class="ob-content" key="${_step}">
        ${s.art}
        <h2 class="ob-title">${Utils.escapeHtml(s.title)}</h2>
        <p class="ob-text">${Utils.escapeHtml(s.text)}</p>
      </div>`;
    // Dots
    document.getElementById('ob-dots').innerHTML = STEPS.map((_, i) =>
      `<span class="ob-dot ${i===_step?'active':''}"></span>`).join('');
    // Botón final
    const btn = document.getElementById('ob-next');
    btn.innerHTML = _step === STEPS.length - 1
      ? 'Empezar <i class="bi bi-rocket-takeoff"></i>'
      : 'Siguiente <i class="bi bi-arrow-right"></i>';
  }

  function next() {
    if (_step < STEPS.length - 1) { _step++; renderStep(); }
    // Sin guarda, y no es un descuido: `window.Utils` NO EXISTE —`utils.js`
    // declara `const Utils`, que queda en el entorno lexico global y no en
    // `window`— asi que `if (window.Utils)` era siempre falso y el confeti del
    // final del recorrido no disparo nunca. Dos lineas mas arriba este mismo
    // archivo llama a `Utils.escapeHtml` sin guarda, y `utils.js` se carga antes
    // que este (index.html). Misma causa que el boton de Apariencia, arreglado
    // el 2026-10-01. Lo vigila `tests/test_globales_del_window.py`.
    else { close(); Utils.confetti({ count: 90 }); }
  }

  function close() {
    localStorage.setItem(SEEN_KEY, '1');
    const ov = document.getElementById('ob-overlay');
    if (ov) { ov.classList.add('ob-closing'); setTimeout(() => ov.remove(), 300); }
  }

  return { open, shouldShow };
})();
window.Onboarding = Onboarding;   // exponer en window
